import { Divider, Tab, Tabs } from '@mui/material';
import { Link, Outlet, useLocation } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import Page from 'src/components/organisms/page/page';

export const EmployeesContainer = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const tabs = [
    {
      href: '/tenant/employees',
      label: t('employees:employees.title'),
    },
    {
      href: '/tenant/employees/groups',
      label: t('employeesGroups:common.title'),
    },
  ];

  return (
    <Page>
      <Tabs
        allowScrollButtonsMobile
        sx={{ mt: 4 }}
        value={tabs.findIndex(tab => tab.href.includes(location.pathname))}
        variant="scrollable">
        {tabs.map(option => (
          <Tab
            component={Link}
            key={option.href}
            label={option.label}
            to={option.href}
          />
        ))}
      </Tabs>
      <Divider />
      <Outlet />
    </Page>
  );
};
